// @flow

export const WS_GET_PAYPAL_LOGIN_URL_REQUEST = 'WS_GET_PAYPAL_LOGIN_URL_REQUEST';
export const WS_GET_PAYPAL_LOGIN_URL_REQUEST_SUCCESS = 'WS_GET_PAYPAL_LOGIN_URL_REQUEST_SUCCESS';

export const WS_GET_PAYPAL_USER_DATA_REQUEST = 'WS_GET_PAYPAL_USER_DATA_REQUEST';

export const WS_GET_PAYPAL_USER_DATA_REQUEST_SUCCESS = 'WS_GET_PAYPAL_USER_DATA_REQUEST_SUCCESS';

export const WS_GET_PAYPAL_REQUEST_ERROR = 'WS_GET_PAYPAL_REQUEST_ERROR';
